export enum ENUMVoucherTypes {
  ECO = "eco",
  GIFT = "gift",
  MEAL = "emv",
  ACTIV = "activ",
  CONSUMPTION = "ecv",
  RETROPASS = "restopass",
  PPP = "ecv",
}
